import { useRef, useEffect } from 'react';
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom';

// icons
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import DensityMediumRoundedIcon from '@mui/icons-material/DensityMediumRounded';
import DensitySmallRoundedIcon from '@mui/icons-material/DensitySmallRounded';
import FormatAlignJustifyRoundedIcon from '@mui/icons-material/FormatAlignJustifyRounded';

import SearchInput from '../SearchInput';

import { Button, Tooltip } from '@mui/material';

import { ActionButton } from '../../Common';

import SortColumnsButton from './Columns';
import FilterButton from './Filters';
import ExportCsv from './ExportCsv'

import useTableStore from '../../../store/table';

const StyledTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: .6rem;
  /* margin: 1.5rem 0; */

  @media ${props => props.theme.breaks.down("md")} {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`

const SearchItems = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 1rem;

  @media ${props => props.theme.breaks.down("md")} {
    min-width: 100%;
  }
`;

const ActionItems = styled.div`
  display: flex;
  gap: .6rem;

  @media ${props => props.theme.breaks.down("md")} {
    width: 100%;
    justify-content: space-between;
  }
`

const Spacer = styled.div`
  width: 2px;
  min-height: 100%;
  background-color: ${props => props.theme.colors.border};
  margin: .5rem 1rem;
`

const BasicActions = styled.div`
  display: flex;
  gap: .6rem;
  min-height: 3.5rem;
`

const NewButton = styled.div`
`

const CustomActionButton = ({title, icon, onClick}) => {
  return (
    <Tooltip title={title}>
      <ActionButton color="icon" variant="outlined" onClick={onClick}>{icon}</ActionButton>
    </Tooltip>
  )
}

const TableHeader = ({ tableId, headers, title, density, toggleDensity, filters, handleSearch, fieldsToSearch, createNew = true, disableSearch = false, exportCsv }) => {

  const search = useRef();

  const navigate = useNavigate();

  const tableSearchTerm = useTableStore(state => state.tableSearchTerm[tableId]);

  const handleNew = () => {
    navigate(`edit`) // changed to non-absolute path
  }

  useEffect(() => {
    if (search.current) search.current.focus();
  }, [])

  return (
    <StyledTableHeader>
      <SearchItems>
        <SearchInput label="Search" onChange={handleSearch} fieldsToSearch={fieldsToSearch} disabled={disableSearch} refPointer={search} value={tableSearchTerm} />
      </SearchItems>
      <ActionItems>
        <BasicActions>
          <CustomActionButton title="Toggle Row Density" icon={density === "normal" ? <FormatAlignJustifyRoundedIcon /> : <DensityMediumRoundedIcon />} onClick={toggleDensity} />
          <FilterButton tableId={tableId} filters={filters} />
          <SortColumnsButton headers={headers} />
          {/* <CustomActionButton title="Download Excel" icon={<GetAppRoundedIcon />} /> */}
          <ExportCsv active={exportCsv} />
        </BasicActions>
        {createNew && <NewButton>
          <Button startIcon={<AddRoundedIcon />} onClick={handleNew} variant="contained">New {title}</Button>
        </NewButton>}
      </ActionItems>
    </StyledTableHeader>
  )
}

 export default TableHeader;
